import {
  actionMutation,
  AuthHeadersEnum,
  HTTPHeaders,
  isError,
  mutateMoneraService,
  MutateMoneraServiceProps,
  serverConsole,
  ShoppingPortalHeadersEnum
} from '@amzn/monera-app-core';
import { emitLatencyMetrics, meterFatalsFromResponse } from '@amzn/monera-app-core/lib/utils/metric-helper';

import { GetAccountLinkingURIRequest } from './types';

export const getAccountLinkingURI = async (getAccountLinkingURI: GetAccountLinkingURIRequest) => {
  // TODO: Implement save/update permissions API call
  const { requestId, asin, tenant, marketplaceId, ubid, sessionId, csrfToken, customerId, localizedProductDetails } = getAccountLinkingURI;

  const getAccountLinkingURIMutationProps: MutateMoneraServiceProps = {
    gqlMutation: actionMutation,
    variables: {
      asin,
      tenant,
      actionType: 'accountlink',
      marketplaceId,
      data: JSON.stringify(localizedProductDetails), 
      customerId
    },
    headers: {
      [ShoppingPortalHeadersEnum.MarketplaceId]: marketplaceId,
      [ShoppingPortalHeadersEnum.UBID]: ubid,
      [ShoppingPortalHeadersEnum.SessionId]: sessionId,
      [AuthHeadersEnum.AntiCsrfToken]: csrfToken,
      [HTTPHeaders.RequestId]: requestId
    }
  };
  serverConsole.log('ACCOUNT LINK PROPS: ', getAccountLinkingURIMutationProps);

  // Enable skill mutation metrics
  const methodName = 'GetAccountLinkingURIMutation';
  const metricName = 'GetAccountLinkingURIMutation';
  const startTime = Date.now();

  const response = await mutateMoneraService<{ response: any }>(getAccountLinkingURIMutationProps).catch((error) =>
    serverConsole.log('error getting account link URI: ', error)
  );

  const mutateMoneraServiceResponseTime = Date.now() - startTime;
  emitLatencyMetrics(methodName, metricName, mutateMoneraServiceResponseTime, requestId, tenant);

  serverConsole.log('ACCOUNT LINK RESPONSE', response);

  meterFatalsFromResponse(response, {
    methodName: 'GetAccountLinkingURI',
    metricName,
    tenant: 'ALEXA_FREE_SKILLS',
    requestId
  });
  if (response === undefined || isError(response)) {
    serverConsole.log('error getting account link URI skill');
    return undefined;
  } else {
    return (response as any).data?.action?.response;
  }
};

export * from './types';
